
import FeaturesCircle from "./FeaturesCircle";

const HeroImage = () => {
  return (
    <div className="relative w-full max-w-2xl mx-auto">
      <div className="rounded-lg p-4">
        <FeaturesCircle />
      </div>
    </div>
  );
};

export default HeroImage;
